import React, { useState, useEffect, useCallback } from "react";

import translations from "./cookie-consent-translations";

const STORAGE_KEY = "davoyage-cookie-consent";

function loadAnalytics() {
  if (document.getElementById("ga-gtag-script")) return;

  const script = document.createElement("script");
  script.id = "ga-gtag-script";
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=UA-49513953-1";
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", "UA-49513953-1");
  gtag("config", "AW-937429566");
}

const CookieConsent = (props) => {
  const t = translations[props.lang] || translations.fr;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "accepted") {
      loadAnalytics();
    } else if (stored !== "refused") {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener("open-cookie-consent", reopen);
    return () => window.removeEventListener("open-cookie-consent", reopen);
  }, []);

  const accept = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    loadAnalytics();
    setVisible(false);
  }, []);

  const refuse = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, "refused");
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={t.ariaLabel}>
      <p className="cookie-banner-text">{t.text}</p>
      <div className="cookie-banner-actions">
        <button className="cookie-refuse" onClick={refuse}>{t.refuse}</button>
        <button className="cookie-accept" onClick={accept}>{t.accept}</button>
      </div>
    </div>
  );
};

export default CookieConsent;
